import { Spin, Tooltip, Popover, Button } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { setCurrentAction } from "../../reducers/actionsReducer";
import {setisShowGridColmns} from "../../reducers/gridLayoutReducer"
import store from "src/store";
import {
  clearGridFiltersTrue,
  refreshGridTrue,
  resetGridLayoutTrue,
  saveGridLayoutTrue,
} from "src/reducers/gridLayoutReducer";
import { EllipsisOutlined } from "@ant-design/icons";

const isEnableOrDisable = (action) => 
  ["Enable/Disable", "Enable", "Disable", "enable", "disable", "enable/disable"].includes(action);

class ActionsToolbar extends Component {
  handleActionClick = (actionName) => {
    const { onActionClick, dispatch } = this.props;
    const actionMap = {
      "Save Layout": saveGridLayoutTrue,
      "Reset Layout": resetGridLayoutTrue,
      "Clear Filters": clearGridFiltersTrue,
      "Refresh": refreshGridTrue,
    };

    if (actionMap[actionName]) {
      dispatch(actionMap[actionName]());
    } else {
      onActionClick(actionName);
    }
  };

  getScreenPermissions = () => {
    const { permissions, screenName, tabName } = this.props;
    const featurePermissions = permissions?.featurePermissions?.[screenName?.toLowerCase()]?.permissions;

    if (permissions?.featurePermissions?.loading) return null;

    return tabName
      ? featurePermissions?.tabs?.find((tab) => tab?.name === tabName)?.actions || []
      : featurePermissions?.actions || [];
  };

  render() {
    const screenPermissions = this.getScreenPermissions();

    if (!screenPermissions) return <Spin />;

    const filteredPermissions = screenPermissions.filter(
      (action) =>
        action.isEnabled && !["View", "Save Layout", "Reset Layout"].includes(action.name)
    );

    const hasEnabledSaveLayout = screenPermissions.some(
      action => action.name === "Save Layout" && action.isEnabled
    );
    
    store?.dispatch(setisShowGridColmns(hasEnabledSaveLayout));
    
    const popoverActions = [
      ...screenPermissions.filter(
        action => ["Save Layout", "Reset Layout"].includes(action.name) && action.isEnabled
      ),
      ...(hasEnabledSaveLayout
        ? [
            { name: "Clear Filters", icon: "clearfilters", isEnabled: true },
            { name: "Refresh", icon: "refresh", isEnabled: true }
          ]
        : [])
    ];
    
    

    const popoverContent = (
      <div className="w-[180px] bg-light-cardBg">
        {popoverActions.map((action) => (
          <div key={action.name} className="flex gap-1.5 items-center list-hover p-2.5 cursor-pointer">
            <span className={`icon ${action.icon?.toLowerCase()}-icon`} />
            <p className="text-light-textWhite" onClick={() => this.handleActionClick(action.name)}>
              {action.name}
            </p>
          </div>
        ))}
      </div>
    );

    return (
      <div>
        <ul className="flex gap-1 items-center justify-end mb-2">
          {filteredPermissions.map((action, index) => (
            <Tooltip
              key={action.name}
              placement={index === filteredPermissions.length - 1 ? "left" : "top"}
              title={
                action.name.toLowerCase() === "kyc-kyb"
                  ? "KYC/KYB"
                  : isEnableOrDisable(action.name.toLowerCase())
                  ? "Enable/Disable"
                  : action.name
              }
            >
              <li>
                <span
                  onClick={() => this.handleActionClick(action.name)}
                  className={`icon md cursor-pointer ${
                    isEnableOrDisable(action.name.toLowerCase()) ? "disable" : action.name.toLowerCase()
                  }-icon`}
                />
              </li>
            </Tooltip>
          ))}
          {popoverActions.length > 0 && (
            <div className="reset-popover">
              <Popover content={popoverContent} trigger="click" placement="bottomRight">
                <Button type="text" shape="circle" icon={<EllipsisOutlined rotate={90} />} />
              </Popover>
            </div>
          )}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = ({ permissions, oidc }) => ({
  permissions,
  userConfig: oidc.user,
});

const mapDispatchToProps = (dispatch) => ({
  setAction: (val) => dispatch(setCurrentAction(val)),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionsToolbar);
